import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
  DataTableServerQuery,
} from '@/components/data-table-builder/data-table.types';
import { ContractingAuthorityRepository } from '@/store/contracting-authority-state/contracting-authority-state.repository';

interface getContractingAuthorityDataTableStructureProps {
  store: ContractingAuthorityRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getContractingAuthorityDataTableStructure = ({
  store,
  createAction,
  rowActions,
  serverQuery,
}: getContractingAuthorityDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.ac.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.ac.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const ancrageColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.ac.table.ancrage',
    accessorKey: 'tutel.nom',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'Autorité contractante',
    plural: 'Autorités contractantes',
    columns: [idColumn, nameColumn, ancrageColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    enableServerActions: true,
    serverQuery,
    target: row => {
      store.set('dto', {
        nom: row.nom,
        tutelId: row.tutel && row.tutel.id != null ? row.tutel.id : null,
      });
      store.set('response', row);
      if (row.tutel && row.tutel.id != null) {
        store.set('tuttelSelected', { name: row.tutel.nom, code: row.tutel.id });
      } else {
        store.set('tuttelSelected', undefined);
      }
    },
    createAction,
    rowActions,
    searchableFields: ['id', 'nom', 'tutel.nom'],
  };
};
